import { render } from "./OilProperty.vue?vue&type=template&id=c9fbf034&scoped=true"
import script from "./OilProperty.vue?vue&type=script&lang=js"
export * from "./OilProperty.vue?vue&type=script&lang=js"

import "./OilProperty.vue?vue&type=style&index=0&id=c9fbf034&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fbf034"]])

export default __exports__